import request from 'utils/request'

export const getMCAXS551InitRequest = () =>
  request({
    url: '/MCAXS551/init',
    method: 'post',
  })
